import React, { VoidFunctionComponent, useEffect, useState } from "react";
import { Checkbox } from "@/components/responsive/commun/checkbox";
import { ExtendedWarranty } from "@/models/scope/productSheet/ExtendedWarranty";
import Utils from "@/libs/Utils";

interface Props {
  warranties: ExtendedWarranty[];
  onTooltipClick?: () => void;
  hasTooltip?: boolean;
  id: string;
  handleSelectWarranty: (isSelectedWarranty: boolean) => void;
  isSelectedWarranty: boolean;
}

export const Warranties: VoidFunctionComponent<Props>= ({
  warranties,
  onTooltipClick,
  hasTooltip = true,
  id,
  handleSelectWarranty,
  isSelectedWarranty,
}) => {
  const [isChecked, setIsChecked] = useState(false);

  useEffect(()=> {
    setIsChecked(isSelectedWarranty);
  }, [isSelectedWarranty]);

  const selectWarrantyHandler = (status: boolean) => {
    setIsChecked(status);
    handleSelectWarranty(status);
  }

  if (!warranties?.length) return null;

  const { cost, popinTitle } = warranties[0];

  return (
    <div className='warranty-block block-layout'>
      <div className='warranty-checkbox-label'>
        <Checkbox
          checked={isChecked}
          callBack={() => selectWarrantyHandler(!isChecked)}
          field={id}
        />
        <p className='warranty-label'>
          {popinTitle}
        </p>
      </div>
      <div className='warranty'>
        <p className='warranty-price'>{`${Utils.formatPriceWithoutTax(cost)} €`} </p>
        {hasTooltip && (
          <img
            src={"/assets/images/responsive/icons/info.svg"}
            onClick={onTooltipClick}
            width='25'
            height='24'
            alt="icone plus d'info"
          />
        )}
      </div>
    </div>
  );
};